const footerLinks = [
  {
    title: "서비스",
    items: [
      { label: "SMS 발송", id: "how-it-works" },
      { label: "LMS 발송", id: "pricing" },
      { label: "MMS 발송", id: "pricing" },
      { label: "대량 발송", id: "features" },
      { label: "API 연동", id: "features" },
      { label: "예약 발송", id: "features" },
    ],
  },
  {
    title: "요금 안내",
    items: [
      { label: "요금제 보기", id: "pricing" },
      { label: "충전 방법", id: "faq" },
      { label: "대량 할인 문의", id: "faq" },
      { label: "세금계산서 발행", id: "faq" },
    ],
  },
  {
    title: "고객 지원",
    items: [
      { label: "자주 묻는 질문", id: "faq" },
      { label: "API 문서", id: "faq" },
      { label: "1:1 문의", id: "faq" },
      { label: "공지사항", id: null },
      { label: "서비스 현황", id: null },
    ],
  },
];

const sns = [
  { icon: "ri-kakao-talk-fill", label: "카카오톡", href: "#" },
  { icon: "ri-instagram-line", label: "인스타그램", href: "#" },
  { icon: "ri-youtube-line", label: "유튜브", href: "#" },
  { icon: "ri-github-line", label: "GitHub", href: "#" },
];

const scrollToSection = (id: string | null) => {
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top, behavior: "smooth" });
};

export default function CtaSection() {
  return (
    <>
      {/* CTA */}
      <section className="bg-[#0d0d1a] py-24 px-6">
        <div className="max-w-2xl mx-auto">
          <div className="relative bg-gradient-to-br from-violet-900/50 to-pink-900/30 border border-violet-500/20 rounded-3xl p-12 text-center overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-violet-600/10 to-pink-600/10 pointer-events-none" />
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-violet-500/20 rounded-full blur-2xl pointer-events-none" />
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-pink-500/15 rounded-full blur-2xl pointer-events-none" />
            <div className="relative z-10">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-violet-600 to-pink-600 mx-auto mb-6">
                <i className="ri-rocket-line text-white text-2xl"></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">지금 시작하세요</h2>
              <p className="text-gray-400 text-base mb-8">
                간편한 가입 후 바로 문자 발송 서비스를 이용하세요.
              </p>
              <button
                onClick={() => scrollToSection("pricing")}
                className="bg-gradient-to-r from-violet-600 to-pink-600 hover:from-violet-500 hover:to-pink-500 text-white px-10 py-3.5 rounded-lg font-semibold text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                무료 회원가입
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#07070f] border-t border-white/[0.06] px-6 pt-16 pb-8">
        <div className="max-w-7xl mx-auto">

          {/* Top: Brand + Links */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-14">

            {/* Brand col */}
            <div className="lg:col-span-2 flex flex-col gap-5">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="flex items-center gap-2.5 cursor-pointer w-fit"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-gradient-to-br from-violet-500 to-pink-500 text-white font-bold text-sm shrink-0">
                  S
                </div>
                <span className="text-white font-bold text-lg">Signal SMS</span>
              </button>

              <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                SKT · KT · LGU+ 3사 통신망 연동으로 빠르고 안정적인 문자 발송 서비스를 제공합니다. 합리적인 가격으로 비즈니스 메시지를 보내세요.
              </p>

              {/* Contact info */}
              <div className="space-y-2.5">
                {[
                  { icon: "ri-phone-line", text: "1588-0000" },
                  { icon: "ri-mail-line", text: "support@plus-sms.store" },
                  { icon: "ri-time-line", text: "평일 09:00 – 18:00 (주말·공휴일 휴무)" },
                ].map((c) => (
                  <div key={c.text} className="flex items-center gap-2.5 text-gray-500 text-sm">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0">
                      <i className={`${c.icon} text-violet-400/70 text-sm`}></i>
                    </div>
                    <span>{c.text}</span>
                  </div>
                ))}
              </div>

              {/* SNS */}
              <div className="flex items-center gap-2 pt-1">
                {sns.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    rel="nofollow noopener noreferrer"
                    target="_blank"
                    className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.05] border border-white/[0.08] text-gray-400 hover:text-white hover:bg-white/10 hover:border-violet-500/40 transition-all cursor-pointer"
                  >
                    <i className={`${s.icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Link cols */}
            <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8">
              {footerLinks.map((col) => (
                <div key={col.title}>
                  <h4 className="text-white font-semibold text-sm mb-4">{col.title}</h4>
                  <ul className="space-y-2.5">
                    {col.items.map((item) => (
                      <li key={item.label}>
                        <button
                          onClick={() => scrollToSection(item.id)}
                          className="text-gray-500 hover:text-gray-300 text-sm transition-colors cursor-pointer whitespace-nowrap text-left"
                        >
                          {item.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/[0.08] to-transparent mb-8" />

          {/* Bottom bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-600 text-xs">
              © 2025 Signal SMS. All rights reserved.
            </p>
            <div className="flex items-center gap-5">
              {["이용약관", "개인정보처리방침", "사업자정보확인"].map((t, i) => (
                <span key={t} className="flex items-center gap-5">
                  <button className="text-gray-600 hover:text-gray-400 text-xs transition-colors cursor-pointer whitespace-nowrap">
                    {t}
                  </button>
                  {i < 2 && <span className="text-white/10 text-xs">|</span>}
                </span>
              ))}
            </div>
          </div>

          {/* Company info */}
          <div className="mt-5 pt-5 border-t border-white/[0.04]">
            <p className="text-gray-700 text-xs leading-relaxed">
              상호명: 주식회사 Signal SMS &nbsp;|&nbsp; 대표자: 홍길동 &nbsp;|&nbsp; 사업자등록번호: 123-45-67890
              &nbsp;|&nbsp; 통신판매업신고: 제2025-서울강남-0000호 &nbsp;|&nbsp; 주소: 서울특별시 강남구 테헤란로 123, 10층
            </p>
          </div>

        </div>
      </footer>
    </>
  );
}